import React, { useState } from "react";
import { Phone, Smartphone, Mail, MessageCircle } from "lucide-react";
import { useShop } from "../context/ShopContext";
import ContactModal from "../components/ContactModal";
import GoogleMap from "../components/GoogleMap";
import Seo from "../components/Seo";

const content = {
  it: {
    title: "Contatti",
    seoDesc: "Contatta IdeaMedia, agenzia web di Padova: telefono, email e form di contatto per preventivi e informazioni su siti web, e-commerce e software.",
    intro: "Siamo sempre disponibili per ricevere le vostre richieste, opinioni e commenti o suggerimenti sul nostro lavoro. Puoi scegliere il tuo canale di comunicazione preferito:",
    everywhere: "Operiamo in Italia e all'estero.",
    legalSeat: "SEDE LEGALE:",
    formTitle: "Scrivici un messaggio",
  },
  en: {
    title: "Contact",
    seoDesc: "Contact IdeaMedia, web agency in Padua, Italy: phone, email and contact form for quotes and information about websites, e-commerce and software.",
    intro: "We are always available to receive your requests, opinions, comments or suggestions about our work. Choose your favourite communication channel:",
    everywhere: "We operate in Italy and abroad.",
    legalSeat: "REGISTERED OFFICE:",
    formTitle: "Send us a message",
  },
};

const Contatti = () => {
  const { lang } = useShop();
  const c = content[lang];
  const [modalOpen, setModalOpen] = useState(false);

  const channels = [
    { icon: Phone, label: "+39 049 8245941", href: "tel:0498245941" },
    { icon: Smartphone, label: "+39 329 8044265", href: "tel:3298044265" },
    { icon: Smartphone, label: "+39 351 9370920", href: "tel:3519370920" },
    { icon: Mail, label: "@ideamedia", onClick: () => setModalOpen(true) },
    { icon: MessageCircle, label: "Whatsapp", href: "https://wa.me/+393298044265", external: true },
  ];

  return (
    <div data-testid="contact-page">
      <Seo title={c.title} description={c.seoDesc} />

      <div className="idm-contactx">
        {/* Dark left panel - original layout */}
        <aside className="idm-contactx-dark" data-testid="contact-info">
          <h1 className="idm-contactx-title">{c.title}</h1>

          <p className="idm-contactx-intro">{c.intro}</p>

          <ul className="idm-contactx-channels">
            {channels.map((ch) => {
              const Icon = ch.icon;
              const inner = (
                <>
                  <Icon size={26} strokeWidth={2} />
                  <span className="idm-contactx-pill">{ch.label}</span>
                </>
              );
              return (
                <li key={ch.label}>
                  {ch.onClick ? (
                    <button onClick={ch.onClick} data-testid="contact-channel-email">
                      {inner}
                    </button>
                  ) : (
                    <a
                      href={ch.href}
                      {...(ch.external ? { target: "_blank", rel: "noreferrer" } : {})}
                      data-testid={`contact-channel-${ch.label.replace(/[\s@.+]/g, "-")}`}
                    >
                      {inner}
                    </a>
                  )}
                </li>
              );
            })}
          </ul>

          <div className="idm-contactx-legal">
            <p>{c.everywhere}</p>
            <p>
              <span>{c.legalSeat}</span> Via Fornaci 215/B, 35131 Padova
            </p>
            <p>
              <span>VAT</span> IT05117210285
            </p>
          </div>
        </aside>

        {/* Full-height map with custom IdeaMedia marker */}
        <div className="idm-contactx-map">
          <GoogleMap />
        </div>
      </div>

      <ContactModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        title={c.formTitle}
      />
    </div>
  );
};

export default Contatti;
